import { Directive, ElementRef, Input , OnInit} from '@angular/core';

@Directive({
  selector: '[appFontfamily]'
})
export class FontfamilyDirective {
    @Input('appFontfamily') font;

    constructor(private el: ElementRef) {
    }
    ngOnInit() {
        if(this.font!= "")
            this.el.nativeElement.style.cssText = ' font-family : ' + this.font +' !important;';
    }
}



// WEBPACK FOOTER //
// ./src/app/fontfamily.directive.ts